import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { ICONS } from "@/lib/icons";
import copy from "@/content/homepage-copy.json";

const { faqChevron: Chevron } = ICONS;

// Odpowiedzi finalizujemy razem z regulaminem, cennikiem i licencją (spec §12).
// Do tego czasu — kontrolowany placeholder, bez zmyślonych treści.
const PENDING_ANSWER = "Pełną odpowiedź opublikujemy razem z regulaminem, cennikiem i licencją.";

export const FaqSection = () => {
  const faq = copy.faq;
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]" data-testid="faq-section">
      <SectionHeading chapter="07 — FAQ" title="Najczęściej zadawane pytania" />
      <div className="mx-auto mt-14 max-w-3xl">
        {faq.map((question, i) => {
          const isOpen = openIndex === i;
          return (
            <Reveal key={i} delay={(i % 4) * 0.04}>
              <div className="border-b border-brand-line">
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    id={`faq-button-${i}`}
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    data-testid={`faq-question-${i}`}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="font-display text-base font-medium text-brand-text sm:text-lg">{question}</span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-line text-brand-accent transition-transform duration-300 ${
                        isOpen ? "rotate-180 bg-brand-accent/10" : ""
                      }`}
                    >
                      <Chevron size={18} strokeWidth={1.75} aria-hidden="true" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      id={`faq-panel-${i}`}
                      role="region"
                      aria-labelledby={`faq-button-${i}`}
                      data-testid={`faq-answer-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pb-5 pr-12 text-sm leading-relaxed text-brand-sec">{PENDING_ANSWER}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
